import { render, staticRenderFns } from "./SupplierGrid.vue?vue&type=template&id=883ff900&scoped=true"
import script from "./SupplierGrid.vue?vue&type=script&lang=js"
export * from "./SupplierGrid.vue?vue&type=script&lang=js"
import style0 from "./SupplierGrid.vue?vue&type=style&index=0&id=883ff900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ff900",
  null
  
)

export default component.exports